<template>
    <div id="contact_wrapper">
        <section id="contact" style="overflow-x: hidden!important">
            <b-container class="pt-200 pb-60">
                <b-row>
                    <b-col md="5">
                        <p class="gotham-book fade-in-up-element">
                            <span class="gotham-bold">Where.</span>
                            <br>
                            <a href="" class="text-black" target="_blank">
                                1063 eglinton avenue west
                                <span class="d-block"></span>
                                toronto, ontario m6c 2c9
                            </a>
                        </p>
                        <p class="gotham-book fade-in-up-element">
                            <span class="gotham-bold">Who + How.</span>
                            <span class="d-block mt-1"></span>
                            <a href="tel:416-783-3311" class="text-black" target="_blank">
                                416.783.3311
                            </a>
                            <span class="d-block"></span>
                            <a href="mailto:letsmeet@1063eglinton.ca" class="text-black" target="_blank">
                                letsmeet@1063eglinton.ca
                            </a>
                            <!--  -->
                            <span class="d-block mt-3"></span>
                            Marci MacEachern
                            <br>
                            <a href="mailto:marci@1063eglinton.ca" class="text-black" target="_blank">
                                marci@guidelinesad.com
                            </a>
                            <!--  -->
                            <span class="d-block mt-3"></span>
                            Flavio Cappella
                            <br>
                            <a href="mailto:flavio@1063eglinton.ca" class="text-black" target="_blank">
                                flavio@guidelinesad.com
                            </a>
                        </p>
                    </b-col>
                    <b-col md="7">
                        <div class="fade-in-up-element mt-100">
                            <img src="/img/get-in-touch.svg" alt="Get In Touch" class="w-100 d-block ">
                        </div>
                    </b-col>
                </b-row>
            </b-container>
            <section class="conclusion">
                <iframe src="https://snazzymaps.com/embed/485380" width="100%" height="600px" style="border:none;" class="d-block"></iframe>
            </section>
            <AppFooter />
        </section>
    </div>
</template>

<script>
import { gsap } from "gsap";
import { ScrollSmoother } from "gsap/ScrollSmoother";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";

export default {
    head: {
      title: "Guidelines Advertising Inc - 1063 Eglinton Ave",
      meta: [
        {
            hid: "description",
            content:
            "Guidelines Advertising is a full-service real estate marketing company with over 35 years experience in Toronto, Ontario, Canada."
        },
        { 
            hid: 'keywords', 
            name: 'keywords', 
            content: 'Toronto,Real estate décor consulting Toronto, real estate, marketing, toronto, branding, social media, web development, interior design, print, advertising, content marketing, eglinton'
        }
      ]
    },
    data() {
        return {
            scrollSmoother_contact: null,
            textAnimation_about: null,
            fadeInUpElement_contact: null
        }
    },
    components: {
        WhatWeDo: () => import('@/components/WhatWeDo'),
        WhereWeDoIt: () => import('@/components/WhereWeDoIt'),
        AppFooter: () => import('@/components/AppFooter'),
    },
    mounted() {
        gsap.registerPlugin(ScrollTrigger, ScrollSmoother, SplitText);
        ScrollTrigger.refresh();
        setTimeout(() => {
            // CALL THIS FIRST SINCE ITS TECHNICALLY A SCROLLTRIGGER, SO ANY SCROLLTRIGGERS FOLLOWING THIS WOULD BE BUILT OFF OF THE SCROLLSMOOTHER
            this.initscrollSmoother_contactPage();
            // 
            this.initImgElReveal_contactPage();
        }, 500)
    },
    methods: {
        initscrollSmoother_contactPage() {
            this.scrollSmoother_contact = ScrollSmoother.create({
                wrapper: '#contact_wrapper',
                content: "#contact",
                smooth: 3,
                effects: true
            });
            this.scrollSmoother_contact.effects(".plax-img", { speed: "auto" });
        },
        initImgElReveal_contactPage() {
            let fadeInUpEl = document.querySelectorAll(".fade-in-up-element");

            fadeInUpEl.forEach((container) => {
                let fadeInUpElement_contact = this.fadeInUpElement_contact;
                fadeInUpElement_contact = gsap.timeline({
                    scrollTrigger: {
                        trigger: container,
                        start: "center bottom",
                        stagger: 0.2
                    }
                });

                fadeInUpElement_contact.set(container, { autoAlpha: 1 });
                fadeInUpElement_contact.from(container, 1, {
                    opacity: 0,
                    y: 100,
                    ease: "power2.out"
                });
            });
        },
    },
    beforeDestroy() {
        setTimeout(() => {
            this.scrollSmoother_contact.kill();
        }, 500)
    }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/variables';

#contact {
    background-image: url('/img/stipple-background.jpg');
    background-position: center;
    background-size: cover;
    width: 100%;
    z-index: 2;

    #where-we-do-it {
        .pink-bg-overlay {
            position: absolute;
            top: 0;
            width: 100%;
            height: 20px;
            background-color: rgba($color: #850147, $alpha: 0.55);
        }
    }

    .ga-circular-stamp {
        position: absolute;
        right: -100px;
        bottom: -100px;
        width: 100%;
        max-width: 280px;
        z-index: 1;
    }
}


</style>